export const TRANSLATIONS = {
  //id:"ID",
  //wyID: "WyScout ID",
  imageURL: "Imagen Jugador",
  shortName: "Nombre Corto",
  minutesThreshold: "Alarma",
  signalDate: "Fecha Alarma",
  initialAge: "Edad Alarma",
  teamImageDataURL: "Imagen Equipo",
  team: "Equipo",
  competitionName: "Competición",
  season: "Temporada",
  currentTeamImageURL: "Imagen Equipo Actual",
  currentTeamName: "Equipo Actual",
  nationalTeamImageURL: "Imagen Equipo Nacional",
  nationalTeamName: "Equipo Nacional",
  birthDate: "Fecha de Nacimiento",
  birthAreaName: "País de Nacimiento",
  appearencesTotal: "Partidos",
  goalTotal: "Goles",
  minutesPlayedTotal: "Minutos Jugados",
  competitionArea: "Area de la Competición",
  competitionDivisionLevel: "Nivel de la Competición",
  roleName: "Rol",
  numReports: "Número de Informes",
  firstReport: "Fecha Primer Informe",
  lastReport: "Fecha Último Informe",
  firstName: "Nombre",
  lastName: "Apellido",
  passportAreaAlpha3code: "Código Area Pasaporte",
  foot: "Pie",
  height: "Altura",
  weight: "Peso",
  substituteOutTotal: "Substituciones",
  penaltiesTotal: "Penáltis",
  redCardsTotal: "Tarjetas Rojas",
  yellowCardTotal: "Tarjetas Amarillas",
  substituteInTotal: "Participaciones desde Banquillo",
  //substituteOnBenchTotal: "substituteOnBenchTotal",
  roleCode2: "Código Rol",
  teamAreaName: "Area del Equipo",
  lastReportRating: "Val. Último Informe",
  firstReportRating: "Val. Primer Informe",
  aifID: "Id AiFootball",
  aifAvgRatingTotal: "Val. Scout Histórica",
  aifAvgRating_1Y: "Val. Scout 1 año",
  aifAvgRating_2Y: "Val. Scout 2 años",
  aifAvgFinalDestinationTotal: "Destino Medio Histórico",
  aifAvgFinalDestination_1Y: "Destino Medio 1 año",
  aifAvgFinalDestination_2Y: "Destino Medio 2 años",
  aifReportAppearancesWeekly: "Apariciones Once Semanal",
  aifReportConsecutiveAppearancesWeekly: "Apariciones Consecutivas Once Semanal",
  aifReportAppearancesMonthly: "Apariciones Once Mensuales",
  aifReportConsecutiveAppearancesMonthly: "Apariciones Consecutivas Once Mensual",
};